// Components
import Skeleton from '@mui/material/Skeleton';

// Styles
import styles from './index.module.sass';

export default function LoadingItem({ screenSize }) {
  return (
    <div className={styles.LoadingItem}>
      <Skeleton variant='rectangular' animation='wave' className={styles.productImage} />
      <Skeleton variant='rectangular' animation='wave' className={styles.productName} />
      <Skeleton variant='rectangular' animation='wave' className={styles.productPrice} />
    </div>
  );
}
